module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch9"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("SAN FRANCISCO")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Nick Motrenko admired Rachel Amber’s nicely rounded butt as he boosted her over the sagging chain-link fence that ran along the perimeter of the old, abandoned fort.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Like Nick, Rachel was young and energetic. And really good-looking, with a lithe, supple body, long dark hair sweeping halfway down her back, and cool blue eyes that sparkled like sapphires. Besides, the word was that she was really good in bed.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("As soon as they both got over the fence, Rachel asked, “Won’t we set off some alarms or something?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Naw,” said Nick. “This place has been abandoned for so long, nobody gives a damn about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Which is why Nick liked the ancient fort. Beyond its gray, weathered stones he could see the glittering bay and the graceful Golden Gate Bridge. Best of all, there were no sensors or cameras or microphones planted to spy on people. Not like in town, where you couldn’t hiccup anywhere without half a dozen government sensors taking it down, not even in church.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Nick was athletically lean and tall, but seemed physically incapable of smiling. His high-cheeked face was almost always set in a dour, doleful grimace. Some of his buddies called him a sourpuss, although more than a few young women thought him soulful.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Rachel slowly turned a full circle, taking in the ankle-high grass waving in the wind coming off the bay, the gnarled and bowed trees, the scruffy clumps of thick bushes sprouting here and there.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You’d think somebody would’ve developed this land. Y’know, built houses on it or something.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“The government owns the land. This used to be an anti-missile base, back in the old days.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Still, they could put a lot of housing here.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Nick shrugged. “The government doesn’t give a damn about making money, just spending it.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I guess,” she said, stepping carefully through the overgrown grass and weeds, looking out for broken glass or other junk. “It’s sorta like a park. Kind of wild.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Good place to be alone together,” Nick said, as he took her hand and led her toward the edge of the bluff that overlooked the bay. The sun was hot, the wind off the water cool, and there was nobody else around to bother them.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The two of them were in skintight jeans. Rachel wore a self-powered sleeveless top that shifted hues as she walked, like a shimmering rainbow. Nick had on the latest-mod wraparound hiker’s blouse, hanging shapelessly to his hips.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Let’s get out of the sun,” Nick suggested. He started toward a small stand of stunted trees off to their left. The wind made their branches rustle.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Once they stretched out side by side in the shade of the trees, Rachel said, “It’s like we’ve got a whole world just to ourselves, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Sort of.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Like New Earth.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Propping himself on one elbow, Nick asked, “What do you know about New Earth?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“All the chat rooms are full of the images that the star travelers brought back. It looks like the Garden of Eden, sort of.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Nick’s normal scowl deepened. “The star travelers. And that alien woman they brought back with them.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“She looks just like a human being.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“She’s an alien.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You haven’t shown much of their stuff on your blog,” said Rachel.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I don’t just run what everybody else is showing. I want original material for my blog.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I saw your piece about ‘beware of Greeks bearing gifts,’” Rachel said. “Why are you so suspicious?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She was smiling at him, teasing him, really, but Nick didn’t catch it. Quite seriously, he replied, “Because I want to interview this Jordan Kell character and the government won’t let me do it. They won’t let "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("anybody")]), _vm._v(" get near him.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She shrugged deliciously. “He’s an important man. He’s been to another star.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That’s what I want to be,” Nick said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“A star traveler?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“An important man. I want to "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("be")]), _vm._v(" somebody. Not just another nobody living on a government subsidy.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“How are you going to do that?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I dunno. Interviewing the star traveler for my blog would be a good start.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Gee, yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“But they won’t let me near him. They’ve got him all buttoned up.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“They’re protecting him.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“From what?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“From nut cases and weirdos, I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You think I’m a nut case or a weirdo?” he asked, almost belligerently.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No,” Rachel said softly. “I think you’re very intense, very dedicated.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Nick cupped his hands behind his head and gazed through the trees’ leafage into the cloud-flecked sky.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I want to "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("be")]), _vm._v(" somebody,” he repeated in a whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Rachel turned to him. “Y’know, there’s a guy down in Mountain View that I saw a couple of times. You ought to go see him.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“A guy? Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“He’s a guru or something. You know, like a holy man. Very wise. Maybe he could help you.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“A holy man?” Disdain was clear in Nick’s voice.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Not holy like a priest. Not religious. But he helps people. Helps them to find their way.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Sounds like a nut case.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Very seriously, Rachel said, “He helped me. I wouldn’t have found you if he hadn’t helped me.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Really?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Really.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("For the first time that day, Nick Motrenko smiled. Later, he smiled even more. The word he had heard about Rachel was right. Better than right. And they hadn’t even needed a bed.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-230f158d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter9.vue
// module id = 99
// module chunks = 0